export const tableHeader = [
  {
    id: 'name',
    type: 'text',
    value: 'Nome',
  },
  {
    id: 'description',
    type: 'text',
    value: 'Descrição',
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
